import React from 'react';
import {compose} from 'recompose';
import {withDatabase} from '@nozbe/watermelondb/react';
import withState from 'src/redux/wrapper';
import {withObservables} from '@nozbe/watermelondb/react';
import {Q} from '@nozbe/watermelondb';
import {Text, View} from 'react-native';
import {Typography} from 'src/styles';
import {NestableDraggableFlatList} from 'react-native-draggable-flatlist';
import PromptListItem from 'src/modules/organization/components/prompt-list-item';
import {updateRank} from 'src/common-utils/rank';
import {useDatabase} from '@nozbe/watermelondb/react';
import {useStyle} from 'src/providers/style';

const PromptTypeList = ({
  promptType,
  prompts,
  canEdit,
  editCallback,
  canDelete,
  deleteCallback,
}: any) => {
  const database = useDatabase();
  const styles = useStyle();

  return (
    <View key={'prompt-type-' + promptType} style={[styles.marginBottom]}>
      <Text
        style={[Typography.P2, styles.marginLBottom, styles.paddingHorizontal]}>
        {promptType}
      </Text>
      <NestableDraggableFlatList
        nestedScrollEnabled={true}
        data={prompts}
        renderItem={({item, index, drag, isActive}): any => (
          <PromptListItem
            key={'prompt-' + index}
            prompt={item}
            drag={drag}
            isActive={isActive}
            canEdit={canEdit}
            editCallback={() => editCallback(item)}
            canDelete={canDelete}
            deleteCallback={() => deleteCallback(item)}
          />
        )}
        keyExtractor={(item, index) => `draggable-item-${item.id}-${index}`}
        onDragEnd={async ({data}: any) => updateRank(database, data)}
      />
    </View>
  );
};

export default compose(
  withDatabase,
  withState,
  withObservables([], ({promptType, database, authentication}: any) => ({
    prompts: database
      ?.get('prompts')
      .query(
        Q.where('deleted_at', null),
        Q.where('prompt_type', promptType),
        Q.where('_partition', authentication.selectedGroup),
        Q.sortBy('rank', Q.asc),
      ),
  })),
)(PromptTypeList);
